export default "__VITE_ASSET___5Lmic6a__"